import PageRenderer from "../components/PageRenderer";

const MitmachenAusverkauft = () => <PageRenderer pageName="Mitmachen" analyticsPath="/mitmachen" />;

export default MitmachenAusverkauft;
